exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.md-help-outline[data-v-6b8cdc9e] {\n  color: #ff6611;\n}\n.report-content[data-v-6b8cdc9e] {\n  width: 100%;\n}\nselect.form-control[data-v-6b8cdc9e] {\n  margin-top: 1rem;\n  width: 90%;\n}\n", ""]);

